import DomainEntity from '@/models/DomainEntity'

export default class StrategyBuildings extends DomainEntity {
  static get collectionName() {
    return 'strategybuildings/'
  }

  static get parentKey() {
    return 'strategy'
  }

  static defaults() {
    return {
      buy: [],
      sell: [],
    }
  }
}
